export const TOTAL_DATE_CELLS = 42;

// 비교
export const isBefore = (a, b) => a.getTime() < b.getTime();
export const isBeforeByDate = (a, b) => {
  const aDate = new Date(a.getFullYear(), a.getMonth(), a.getDate());
  const bDate = new Date(b.getFullYear(), b.getMonth(), b.getDate());
  return aDate.getTime() < bDate.getTime();
};
export const isAfter = (a, b) => a.getTime() > b.getTime();
export const isAfterByDate = (a, b) => {
  const aDate = new Date(a.getFullYear(), a.getMonth(), a.getDate());
  const bDate = new Date(b.getFullYear(), b.getMonth(), b.getDate());
  return aDate.getTime() > bDate.getTime();
};

// month 관련
export const getDaysInMonth = (year, month) =>
  new Date(year, month + 1, 0).getDate();

export const getFirstDayOfMonth = (year, month) =>
  new Date(year, month, 1).getDay();

export const getPrevMonthLastDate = (year, month) =>
  new Date(year, month, 0).getDate();

// 날짜 범위 안에 있는지
export const isBetweenDates = (date, d1, d2) => {
  if (!d1 || !d2) return false;
  return (date >= d1 && date <= d2) || (date <= d1 && date >= d2);
};

// 날짜 범위 배열
export const getDatesBetween = (startDate, endDate, delimiter = "-") => {
  if (!startDate || !endDate) return [];
  const dates = [];
  let current = new Date(startDate);
  while (current <= endDate) {
    dates.push(formatDateTime(current, delimiter));
    current.setDate(current.getDate() + 1);
  }
  return dates;
};

// 특정 month의 모든 날짜
export const getDatesOfMonth = (year, month, delimiter = "-") => {
  const start = new Date(year, month, 1);
  const end = new Date(year, month + 1, 0);
  return getDatesBetween(start, end, delimiter);
};

// Date -> 문자열 (YYYY-MM-DD 또는 YYYY.MM.DD.)
export const formatDateTime = (date, format = "YYYY-MM-DD") => {
  if (!date || !(date instanceof Date)) return "";

  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  return format
    .toUpperCase()
    .replace("YYYY", y)
    .replace("MM", m)
    .replace("DD", d)
    .replace("DAY", days[date.getDay()]);
};

// 문자열 -> Date
export const parseDate = (dateString, delimiter = "-") => {
  if (!dateString) return null;
  const [y, m, d] = dateString.split(delimiter).map(Number);
  return new Date(y, m - 1, d);
};

export const formatDateToCustomString = (date, customString = "MM.DD (d)") => {
  if (!date) return null;

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const hours = date.getHours();

  const tokens = {
    YYYY: date.getFullYear(),
    MM: String(date.getMonth() + 1).padStart(2, "0"),
    DD: String(date.getDate()).padStart(2, "0"),
    d: days[date.getDay()],
    HH: String(hours).padStart(2, "0"),
    hh: String(hours % 12 || 12).padStart(2, "0"),
    mm: String(date.getMinutes()).padStart(2, "0"),
    ss: String(date.getSeconds()).padStart(2, "0"),
    A: hours < 12 ? "AM" : "PM",
  };

  return customString.replace(
    /YYYY|MM|DD|d|HH|hh|mm|ss|A/g,
    (match) => tokens[match],
  );
};

// 캘린더 표시의 시작 경계: 해당 월의 시작일에서 7일 전 날짜
export const getCalendarFirstDay = (date) => {
  if (!date) return;

  const newDate = new Date(date.getFullYear(), date.getMonth(), 1);
  newDate.setDate(newDate.getDate() - 7);

  const resultYear = newDate.getFullYear();
  const resultMonth = newDate.getMonth() + 1;
  const resultDay = newDate.getDate();
  return `${resultYear}-${String(resultMonth).padStart(2, "0")}-${String(resultDay).padStart(2, "0")}`;
};

// 캘린더 표시의 종료 경계: 해당 월의 마지막 날에서 14일 후 날짜
export const getCalendarLastDay = (date) => {
  if (!date) return;

  const year = date.getFullYear();
  const month = date.getMonth();
  const lastDayDate = getDaysInMonth(year, month);

  const lastDateOfMonth = new Date(year, month, lastDayDate);
  lastDateOfMonth.setDate(lastDateOfMonth.getDate() + 14);

  const resultYear = lastDateOfMonth.getFullYear();
  const resultMonth = lastDateOfMonth.getMonth() + 1;
  const resultDay = lastDateOfMonth.getDate();

  return `${resultYear}-${String(resultMonth).padStart(2, "0")}-${String(resultDay).padStart(2, "0")}`;
};
